import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL || "https://tspm-api.abrandfantastic.workers.dev";
const SITE_URL = "https://pop-boutique.pages.dev";

const DEFAULTS = {
  // Site mode
  pop_holding_mode:      "false",
  // Home page — hero images
  pop_hero_img:          "",
  pop_hero_2:            "",
  pop_hero_3:            "",
  // Home page — featured section
  pop_featured_heading:  "The Hot List",
  pop_featured_sub:      "Our most-wanted vintage-inspired pieces, curated just for you.",
  // Home page — hero text
  pop_hero_tagline_1:    "Bold • Loud • Unapologetic",
  pop_hero_tagline_2:    "Modern Statement Wear",
  pop_hero_tagline_3:    "Graphic Fashion with Attitude",
  pop_hero_tagline_4:    "Designed to Be Seen",
  pop_hero_tagline_5:    "Wear the Message",
  pop_hero_cta:          "Shop the Vault",
  // Home page — announcement bar
  pop_ticker_1:          "Free shipping on orders over £75",
  pop_ticker_2:          "Vintage Tees from the Vault",
  pop_ticker_3:          "Lollipop + Popsicle",
  // Home page — brand teasers
  pop_lollipop_badge:    "Featured Brand",
  pop_lollipop_desc:     "Modern statement wear designed to be bold, loud, and unapologetic.",
  pop_lollipop_cta:      "Explore Lollipop",
  pop_popsicle_badge:    "Featured Brand",
  pop_popsicle_desc:     "Retro gaming vibes and electric street style from the 80s arcade era.",
  pop_popsicle_cta:      "Explore Popsicle",
  // About page — hero
  pop_about_hero_badge:    "Our Story",
  pop_about_hero_h1:       "Two Brands,",
  pop_about_hero_h2:       "One Love",
  pop_about_hero_sub:      "Born from a passion for vintage fashion and sustainable style, pop.boutique brings together two iconic t-shirt brands from 15 years ago.",
  // About page — Lollipop story
  pop_about_lollipop_body: "Sweet as a summer day. Lollipop captured the essence of 50s diner culture with pastel dreams and cherry-topped designs. Every tee tells a story of milkshakes, jukeboxes, and endless sunny afternoons.",
  pop_about_lollipop_b1:   "Pastel color palettes",
  pop_about_lollipop_b2:   "Vintage diner aesthetics",
  pop_about_lollipop_b3:   "Soft, nostalgic vibes",
  // About page — Popsicle story
  pop_about_popsicle_body: "Bold as the neon lights. Popsicle brought the electric energy of 80s arcades to streetwear. Think synthwave sunsets, pixel art heroes, and that rush of hitting a new high score.",
  pop_about_popsicle_b1:   "Neon color explosions",
  pop_about_popsicle_b2:   "Retro gaming graphics",
  pop_about_popsicle_b3:   "80s arcade culture",
  // About page — timeline
  pop_about_timeline_h:    "The Journey",
  pop_about_tl1_year:      "2010", pop_about_tl1_title: "The Beginning",   pop_about_tl1_desc: "Lollipop and Popsicle launch as separate vintage-inspired t-shirt brands.",
  pop_about_tl2_year:      "2012", pop_about_tl2_title: "Cult Following",   pop_about_tl2_desc: "Both brands gain dedicated followings in the underground fashion scene.",
  pop_about_tl3_year:      "2015", pop_about_tl3_title: "The Vault",        pop_about_tl3_desc: "Production pauses, but the remaining stock becomes highly sought after.",
  pop_about_tl4_year:      "2024", pop_about_tl4_title: "pop.boutique",     pop_about_tl4_desc: "The brands unite under one roof, bringing vintage treasures to a new generation.",
  // About page — values
  pop_about_values_h:      "What We Believe",
  pop_about_val1_title:    "Sustainable Fashion", pop_about_val1_desc: "Every vintage tee is a step towards sustainable style. No new production, just timeless pieces finding new homes.",
  pop_about_val2_title:    "Authentic Style",     pop_about_val2_desc: "Real vintage, not replicas. Each piece carries its own history and character that can't be manufactured.",
  pop_about_val3_title:    "Community First",     pop_about_val3_desc: "We're building a community of like-minded vintage lovers who appreciate the stories behind the style.",
  // About page — CTA
  pop_about_cta_h:         "Ready to Explore?",
  pop_about_cta_sub:       "Dive into our collection of vintage treasures from the vault.",
  pop_about_cta_btn1:      "Shop Lollipop",
  pop_about_cta_btn2:      "Shop Popsicle",
  // Holding page — image
  pop_holding_img:       "",
  // Holding page — text
  pop_holding_headline:  "Should Lollipop make a come back?",
  pop_holding_body:      "It once meant something.\nI'm thinking about bringing it back\nbut only if you want me to.",
  pop_holding_badge:     "LOLLIPOP",
  pop_holding_caption:   "DJ Mon on the ones and twos",
  pop_holding_cta:       "Yes. Bring it Back",
  pop_holding_no_spam:   "No spam. Just updates if Lollipop returns.",
};

const HOME_TEXT_FIELDS = [
  { key: "pop_featured_heading", label: "Featured heading", hint: 'Section title e.g. "The Hot List"' },
  { key: "pop_featured_sub",     label: "Featured subtext",  hint: "One line below the heading" },
  { key: "pop_hero_tagline_1", label: "Tagline 1", hint: "First rotating tagline in the hero" },
  { key: "pop_hero_tagline_2", label: "Tagline 2", hint: "Second rotating tagline" },
  { key: "pop_hero_tagline_3", label: "Tagline 3", hint: "Third rotating tagline" },
  { key: "pop_hero_tagline_4", label: "Tagline 4", hint: "Fourth rotating tagline (optional)" },
  { key: "pop_hero_tagline_5", label: "Tagline 5", hint: "Fifth rotating tagline (optional)" },
  { key: "pop_hero_cta",       label: "CTA button", hint: 'Shop button label e.g. "Shop the Vault"' },
  { key: "pop_ticker_1",       label: "Banner — item 1", hint: "First scrolling announcement" },
  { key: "pop_ticker_2",       label: "Banner — item 2", hint: "Second scrolling announcement" },
  { key: "pop_ticker_3",       label: "Banner — item 3", hint: "Third scrolling announcement" },
  { key: "pop_lollipop_badge", label: "Lollipop — badge",   hint: 'Label above heading e.g. "Featured Brand"' },
  { key: "pop_lollipop_desc",  label: "Lollipop — description", hint: "One or two lines under the brand name" },
  { key: "pop_lollipop_cta",   label: "Lollipop — button",  hint: 'e.g. "Explore Lollipop"' },
  { key: "pop_popsicle_badge", label: "Popsicle — badge",   hint: 'Label above heading e.g. "Featured Brand"' },
  { key: "pop_popsicle_desc",  label: "Popsicle — description", hint: "One or two lines under the brand name" },
  { key: "pop_popsicle_cta",   label: "Popsicle — button",  hint: 'e.g. "Explore Popsicle"' },
];

const HOLDING_TEXT_FIELDS = [
  { key: "pop_holding_headline", label: "Headline",      hint: 'e.g. "Should Lollipop make a come back?"' },
  { key: "pop_holding_body",     label: "Body copy",     hint: "Paragraph shown below the headline", multiline: true },
  { key: "pop_holding_badge",    label: "Photo badge",   hint: 'Label on the photo e.g. "LOLLIPOP"' },
  { key: "pop_holding_caption",  label: "Photo caption", hint: 'Caption below photo e.g. "DJ Mon on the ones and twos"' },
  { key: "pop_holding_cta",      label: "Button text",   hint: 'e.g. "Yes. Bring it Back"' },
  { key: "pop_holding_no_spam",  label: "Below button",  hint: 'e.g. "No spam. Just updates if Lollipop returns."' },
];

const ABOUT_SECTIONS = [
  {
    heading: "Hero",
    fields: [
      { key: "pop_about_hero_badge", label: "Badge",         hint: 'e.g. "Our Story"' },
      { key: "pop_about_hero_h1",    label: "Heading line 1", hint: 'e.g. "Two Brands,"' },
      { key: "pop_about_hero_h2",    label: "Heading line 2", hint: 'e.g. "One Love"' },
      { key: "pop_about_hero_sub",   label: "Subtext",        hint: "Paragraph below the heading" },
    ],
  },
  {
    heading: "Lollipop — Brand Story",
    fields: [
      { key: "pop_about_lollipop_body", label: "Body paragraph", multiline: true },
      { key: "pop_about_lollipop_b1",   label: "Bullet 1" },
      { key: "pop_about_lollipop_b2",   label: "Bullet 2" },
      { key: "pop_about_lollipop_b3",   label: "Bullet 3" },
    ],
  },
  {
    heading: "Popsicle — Brand Story",
    fields: [
      { key: "pop_about_popsicle_body", label: "Body paragraph", multiline: true },
      { key: "pop_about_popsicle_b1",   label: "Bullet 1" },
      { key: "pop_about_popsicle_b2",   label: "Bullet 2" },
      { key: "pop_about_popsicle_b3",   label: "Bullet 3" },
    ],
  },
  {
    heading: "Timeline",
    fields: [
      { key: "pop_about_timeline_h",  label: "Section heading" },
      { key: "pop_about_tl1_year",    label: "Item 1 — year" },
      { key: "pop_about_tl1_title",   label: "Item 1 — title" },
      { key: "pop_about_tl1_desc",    label: "Item 1 — description" },
      { key: "pop_about_tl2_year",    label: "Item 2 — year" },
      { key: "pop_about_tl2_title",   label: "Item 2 — title" },
      { key: "pop_about_tl2_desc",    label: "Item 2 — description" },
      { key: "pop_about_tl3_year",    label: "Item 3 — year" },
      { key: "pop_about_tl3_title",   label: "Item 3 — title" },
      { key: "pop_about_tl3_desc",    label: "Item 3 — description" },
      { key: "pop_about_tl4_year",    label: "Item 4 — year" },
      { key: "pop_about_tl4_title",   label: "Item 4 — title" },
      { key: "pop_about_tl4_desc",    label: "Item 4 — description" },
    ],
  },
  {
    heading: "Values",
    fields: [
      { key: "pop_about_values_h",   label: "Section heading" },
      { key: "pop_about_val1_title", label: "Card 1 — title" },
      { key: "pop_about_val1_desc",  label: "Card 1 — description" },
      { key: "pop_about_val2_title", label: "Card 2 — title" },
      { key: "pop_about_val2_desc",  label: "Card 2 — description" },
      { key: "pop_about_val3_title", label: "Card 3 — title" },
      { key: "pop_about_val3_desc",  label: "Card 3 — description" },
    ],
  },
  {
    heading: "CTA",
    fields: [
      { key: "pop_about_cta_h",    label: "Heading" },
      { key: "pop_about_cta_sub",  label: "Subtext" },
      { key: "pop_about_cta_btn1", label: "Button 1 text", hint: 'Links to Lollipop shop' },
      { key: "pop_about_cta_btn2", label: "Button 2 text", hint: 'Links to Popsicle shop' },
    ],
  },
];

const HERO_SLIDES = [
  { key: "pop_hero_img", label: "Slide 1", hint: "Main hero image. Landscape, min 1400px wide." },
  { key: "pop_hero_2",   label: "Slide 2", hint: "Second slide — leave empty to disable slider." },
  { key: "pop_hero_3",   label: "Slide 3", hint: "Third slide (optional)." },
];

function Tab({ label, active, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
        active
          ? "border-black text-black"
          : "border-transparent text-gray-400 hover:text-gray-700"
      }`}
    >
      {label}
    </button>
  );
}

export default function PopBoutique() {
  const [content, setContent]     = useState(DEFAULTS);
  const [draft, setDraft]         = useState(DEFAULTS);
  const [saving, setSaving]       = useState({});
  const [toggling, setToggling]   = useState(false);
  const [uploading, setUploading] = useState({});
  const [flash, setFlash]         = useState(null);
  const [tab, setTab]             = useState("home");

  const holdingImgRef = useRef();
  const heroRefs      = [useRef(), useRef(), useRef()];

  const isHolding = content.pop_holding_mode === "true";

  useEffect(() => {
    axios.get(`${API_URL}/api/site-content`)
      .then(({ data }) => {
        const merged = { ...DEFAULTS };
        Object.keys(DEFAULTS).forEach(k => { if (data[k] !== undefined) merged[k] = data[k]; });
        setContent(merged);
        setDraft(merged);
      })
      .catch(() => {});
  }, []);

  async function saveKey(key, value) {
    setSaving(s => ({ ...s, [key]: true }));
    try {
      await axios.put(`${API_URL}/api/site-content`, { [key]: value });
      setContent(c => ({ ...c, [key]: value }));
      showFlash("Saved ✓", "green");
    } catch {
      showFlash("Save failed", "red");
    } finally {
      setSaving(s => ({ ...s, [key]: false }));
    }
  }

  async function toggleMode() {
    const next = isHolding ? "false" : "true";
    setToggling(true);
    try {
      await axios.put(`${API_URL}/api/site-content`, { pop_holding_mode: next });
      setContent(c => ({ ...c, pop_holding_mode: next }));
      setDraft(d => ({ ...d, pop_holding_mode: next }));
      showFlash(next === "true" ? "Holding page is now LIVE" : "Full site is now LIVE", next === "true" ? "yellow" : "green");
    } catch {
      showFlash("Toggle failed", "red");
    } finally {
      setToggling(false);
    }
  }

  async function uploadImage(key, file, ref) {
    setUploading(u => ({ ...u, [key]: true }));
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("key", key);
      const { data } = await axios.post(`${API_URL}/api/site-content/images`, formData);
      setContent(c => ({ ...c, [key]: data.url }));
      setDraft(d => ({ ...d, [key]: data.url }));
      if (ref?.current) ref.current.value = "";
      showFlash("Image uploaded ✓", "green");
    } catch {
      showFlash("Upload failed", "red");
    } finally {
      setUploading(u => ({ ...u, [key]: false }));
    }
  }

  function showFlash(msg, colour) {
    setFlash({ msg, colour });
    setTimeout(() => setFlash(null), 2500);
  }

  const isDirty = key => draft[key] !== content[key];

  return (
    <div className="max-w-3xl mx-auto px-6 py-8 space-y-6">

      {/* Header */}
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-xl font-bold text-gray-900">Pop Boutique</h1>
          <p className="text-sm text-gray-500 mt-0.5">Manage the site content and holding page.</p>
        </div>
        <a href={SITE_URL} target="_blank" rel="noopener noreferrer"
          className="text-xs border border-gray-300 px-3 py-1.5 rounded hover:bg-gray-50 whitespace-nowrap">
          VIEW SITE →
        </a>
      </div>

      {/* Flash */}
      {flash && (
        <div className={`text-sm px-4 py-2 rounded font-medium ${
          flash.colour === "green"  ? "bg-green-50 text-green-700 border border-green-200" :
          flash.colour === "yellow" ? "bg-yellow-50 text-yellow-700 border border-yellow-200" :
          "bg-red-50 text-red-600 border border-red-200"
        }`}>
          {flash.msg}
        </div>
      )}

      {/* Mode toggle — always visible */}
      <div className={`rounded-lg border-2 p-4 transition-colors ${isHolding ? "border-yellow-400 bg-yellow-50" : "border-green-400 bg-green-50"}`}>
        <div className="flex items-center justify-between gap-4">
          <div>
            <p className="text-sm font-semibold text-gray-800">Site Mode</p>
            <p className={`text-xs mt-0.5 font-medium ${isHolding ? "text-yellow-700" : "text-green-700"}`}>
              {isHolding ? "⚠ Holding page is live — visitors see the waitlist form" : "✓ Full site is live — visitors see the main storefront"}
            </p>
          </div>
          <button onClick={toggleMode} disabled={toggling}
            className={`px-4 py-2 rounded text-sm font-semibold transition-colors disabled:opacity-50 ${
              isHolding ? "bg-green-600 hover:bg-green-700 text-white" : "bg-yellow-500 hover:bg-yellow-600 text-black"
            }`}>
            {toggling ? "Switching…" : isHolding ? "Switch to Full Site" : "Switch to Holding Page"}
          </button>
        </div>
        <div className="mt-2 flex gap-3 text-xs">
          <span className={`px-2 py-0.5 rounded-full font-medium ${isHolding ? "bg-yellow-200 text-yellow-800" : "bg-gray-100 text-gray-400"}`}>HOLDING</span>
          <span className={`px-2 py-0.5 rounded-full font-medium ${!isHolding ? "bg-green-200 text-green-800" : "bg-gray-100 text-gray-400"}`}>LIVE</span>
        </div>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200 flex gap-0 -mb-2">
        <Tab label="Home Page"    active={tab === "home"}    onClick={() => setTab("home")} />
        <Tab label="About Page"   active={tab === "about"}   onClick={() => setTab("about")} />
        <Tab label="Holding Page" active={tab === "holding"} onClick={() => setTab("holding")} />
      </div>

      {/* ── HOME PAGE TAB ────────────────────────────────────── */}
      {tab === "home" && (
        <div className="space-y-8 pt-2">

          {/* Hero Text & Announcement */}
          <section>
            <h2 className="text-xs font-bold tracking-widest uppercase text-gray-400 mb-4">Hero Text & Announcement</h2>
            <div className="space-y-4">
              {HOME_TEXT_FIELDS.map(({ key, label, hint }) => (
                <div key={key}>
                  <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
                  <input
                    type="text"
                    value={draft[key] ?? ""}
                    onChange={e => setDraft(d => ({ ...d, [key]: e.target.value }))}
                    className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-gray-500"
                  />
                  {hint && <p className="text-xs text-gray-400 mt-0.5">{hint}</p>}
                  {isDirty(key) && (
                    <button onClick={() => saveKey(key, draft[key])} disabled={saving[key]}
                      className="mt-1.5 text-xs bg-black text-white px-3 py-1 rounded hover:bg-gray-800 disabled:opacity-50">
                      {saving[key] ? "Saving…" : "Save"}
                    </button>
                  )}
                </div>
              ))}
            </div>
          </section>

          {/* Hero Images */}
          <section>
            <h2 className="text-xs font-bold tracking-widest uppercase text-gray-400 mb-1">Hero Slider</h2>
            <p className="text-xs text-gray-400 mb-4">1 image = static hero. 2–3 images = auto-advancing slider.</p>
            <div className="space-y-4">
              {HERO_SLIDES.map(({ key, label, hint }, i) => (
                <div key={key} className="flex items-start gap-4">
                  {content[key]
                    ? <img src={content[key]} alt={label} className="w-28 h-16 object-cover border border-gray-200 rounded shrink-0" />
                    : <div className="w-28 h-16 bg-gray-100 border border-dashed border-gray-300 rounded flex items-center justify-center text-xs text-gray-400 shrink-0">{label}</div>
                  }
                  <div>
                    <p className="text-sm font-medium text-gray-700 mb-1">{label}</p>
                    <button onClick={() => heroRefs[i].current?.click()} disabled={uploading[key]}
                      className="text-xs border border-gray-300 px-3 py-1.5 rounded hover:bg-gray-50 disabled:opacity-50">
                      {uploading[key] ? "Uploading…" : content[key] ? "Replace" : "Upload"}
                    </button>
                    <p className="text-xs text-gray-400 mt-1">{hint}</p>
                    <input ref={heroRefs[i]} type="file" accept="image/*" className="hidden"
                      onChange={e => e.target.files[0] && uploadImage(key, e.target.files[0], heroRefs[i])} />
                  </div>
                </div>
              ))}
            </div>
          </section>

        </div>
      )}

      {/* ── ABOUT PAGE TAB ───────────────────────────────────── */}
      {tab === "about" && (
        <div className="space-y-8 pt-2">
          {ABOUT_SECTIONS.map(({ heading, fields }) => (
            <section key={heading}>
              <h2 className="text-xs font-bold tracking-widest uppercase text-gray-400 mb-4">{heading}</h2>
              <div className="space-y-4">
                {fields.map(({ key, label, hint, multiline }) => (
                  <div key={key}>
                    <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
                    {multiline ? (
                      <textarea
                        rows={3}
                        value={draft[key] ?? ""}
                        onChange={e => setDraft(d => ({ ...d, [key]: e.target.value }))}
                        className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-gray-500 resize-y"
                      />
                    ) : (
                      <input
                        type="text"
                        value={draft[key] ?? ""}
                        onChange={e => setDraft(d => ({ ...d, [key]: e.target.value }))}
                        className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-gray-500"
                      />
                    )}
                    {hint && <p className="text-xs text-gray-400 mt-0.5">{hint}</p>}
                    {isDirty(key) && (
                      <button onClick={() => saveKey(key, draft[key])} disabled={saving[key]}
                        className="mt-1.5 text-xs bg-black text-white px-3 py-1 rounded hover:bg-gray-800 disabled:opacity-50">
                        {saving[key] ? "Saving…" : "Save"}
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>
      )}

      {/* ── HOLDING PAGE TAB ─────────────────────────────────── */}
      {tab === "holding" && (
        <div className="space-y-8 pt-2">

          {/* Holding Hero Image */}
          <section>
            <h2 className="text-xs font-bold tracking-widest uppercase text-gray-400 mb-3">Hero Image</h2>
            <div className="flex items-start gap-4">
              {content.pop_holding_img
                ? <img src={content.pop_holding_img} alt="Hero" className="w-28 h-36 object-cover border border-gray-200 rounded" />
                : <div className="w-28 h-36 bg-gray-100 border border-dashed border-gray-300 rounded flex items-center justify-center text-xs text-gray-400">No image</div>
              }
              <div>
                <button onClick={() => holdingImgRef.current?.click()} disabled={uploading["pop_holding_img"]}
                  className="text-xs border border-gray-300 px-3 py-1.5 rounded hover:bg-gray-50 disabled:opacity-50">
                  {uploading["pop_holding_img"] ? "Uploading…" : "Upload photo"}
                </button>
                <p className="text-xs text-gray-400 mt-1.5">Portrait orientation recommended. Min 600px wide.</p>
                <input ref={holdingImgRef} type="file" accept="image/*" className="hidden"
                  onChange={e => e.target.files[0] && uploadImage("pop_holding_img", e.target.files[0], holdingImgRef)} />
              </div>
            </div>
          </section>

          {/* Holding Text Fields */}
          <section>
            <h2 className="text-xs font-bold tracking-widest uppercase text-gray-400 mb-4">Content</h2>
            <div className="space-y-4">
              {HOLDING_TEXT_FIELDS.map(({ key, label, hint, multiline }) => (
                <div key={key}>
                  <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
                  {multiline ? (
                    <textarea rows={3} value={draft[key] ?? ""}
                      onChange={e => setDraft(d => ({ ...d, [key]: e.target.value }))}
                      className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-gray-500 resize-none" />
                  ) : (
                    <input type="text" value={draft[key] ?? ""}
                      onChange={e => setDraft(d => ({ ...d, [key]: e.target.value }))}
                      className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-gray-500" />
                  )}
                  {hint && <p className="text-xs text-gray-400 mt-0.5">{hint}</p>}
                  {isDirty(key) && (
                    <button onClick={() => saveKey(key, draft[key])} disabled={saving[key]}
                      className="mt-1.5 text-xs bg-black text-white px-3 py-1 rounded hover:bg-gray-800 disabled:opacity-50">
                      {saving[key] ? "Saving…" : "Save"}
                    </button>
                  )}
                </div>
              ))}
            </div>
          </section>

          {/* Preview */}
          <section>
            <h2 className="text-xs font-bold tracking-widest uppercase text-gray-400 mb-3">Preview</h2>
            <div className="border border-gray-200 rounded overflow-hidden text-sm">
              <div className="bg-black text-white px-4 py-2 text-xs tracking-widest uppercase truncate">
                {draft.pop_ticker_1} ✦ {draft.pop_ticker_2} ✦ {draft.pop_ticker_3}
              </div>
              <div className="p-5 grid grid-cols-2 gap-5 bg-white">
                <div className="border-2 border-gray-900 p-2 relative">
                  <span className="absolute top-3 left-3 bg-yellow-400 text-black text-[9px] font-black px-1.5 py-0.5 uppercase tracking-wider">
                    {draft.pop_holding_badge}
                  </span>
                  {content.pop_holding_img
                    ? <img src={content.pop_holding_img} alt="" className="w-full h-32 object-cover" />
                    : <div className="w-full h-32 bg-gray-100 flex items-center justify-center text-xs text-gray-400">photo here</div>
                  }
                  <p className="text-center text-[10px] italic text-gray-500 mt-1.5 pb-1">{draft.pop_holding_caption}</p>
                </div>
                <div>
                  <p className="font-serif font-bold text-base leading-tight mb-2">{draft.pop_holding_headline}</p>
                  <p className="text-xs text-gray-500 mb-3 whitespace-pre-line">{draft.pop_holding_body}</p>
                  <div className="bg-pink-200 text-center text-xs py-2 rounded">{draft.pop_holding_cta} →</div>
                  <p className="text-[10px] text-gray-400 mt-1.5">{draft.pop_holding_no_spam}</p>
                </div>
              </div>
            </div>
          </section>

        </div>
      )}

    </div>
  );
}
